import { IsomorphicLogger } from './logger';

const Logger = new IsomorphicLogger();

type FieldType = 'string' | 'array' | 'stringArray' | 'number' | 'boolean' | 'object';
type FieldTypeMap = {
    string: string;
    array: unknown[];
    stringArray: string[];
    number: number;
    boolean: boolean;
    object: Record<string, unknown>;
};

const isTypeMatch = <T extends FieldType>(value: unknown, type: FieldType): value is FieldTypeMap[T] => {
    switch (type) {
        case 'string':
            return typeof value === 'string';
        case 'number':
            return typeof value === 'number';
        case 'boolean':
            return typeof value === 'boolean';
        case 'array':
            return Array.isArray(value);
        case 'stringArray':
            return Array.isArray(value) && value.every((item) => typeof item === 'string');
        case 'object':
            return typeof value === 'object' && value !== null && !Array.isArray(value);
        default:
            return false;
    }
};

const getField = <T extends FieldType>(
    stringifyJson: string | undefined,
    field: string,
    fieldType: T,
): FieldTypeMap[T] | undefined => {
    if (!stringifyJson) {
        return undefined;
    }

    try {
        const json = JSON.parse(stringifyJson);
        const value = (json as Record<string, unknown>)[field];

        if (field in json) {
            return isTypeMatch<T>(value, fieldType) ? value : undefined;
        }
        return undefined;
    } catch (error) {
        Logger.warn(`Failed to get ${field} from:`, stringifyJson, 'with error:', error);
        return undefined;
    }
};

export const JSONHelpers = {
    getField,
};
